import styled from 'styled-components';

import ContentHeaderStyled from '../../../components/ContentHeader';
import HoverableCard from '../../../components/HoverableCard';
import PaginationStyled from '../../../components/Pagination';
import { CHART_DESCRIPTIONS } from '../chartDescriptions';

type MapsPageProps = {
  className?: string;
};

const MapsPage = ({ className = '' }: MapsPageProps) => (
  <div className={className}>
    <div className="content">
      <ContentHeaderStyled
        className="breadcrumbs"
        title="Maps"
        breadcrumbs={[
          { label: 'Data Visualization', url: '/data-visualization' },
          { label: 'Maps Chart' },
        ]}
      />

      <div className="cards">
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/maps/choropleth']}
          title="Map - Choropleth"
          url="choropleth"
          image="/images/data-viz-maps/map-choropleth.png"
          tags={['comparison']}
        />
        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/maps/bubble']}
          title="Map - Bubbles"
          url="bubble"
          image="/images/data-viz-maps/map-bubbles.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/maps/pikes']}
          title="Map - Spikes"
          url="pikes"
          image="/images/data-viz-maps/map-pikes.png"
          tags={['comparison']}
        />

        <HoverableCard
          description={CHART_DESCRIPTIONS['/data-visualization/maps/scatter']}
          title="Map - Scatter"
          url="scatter"
          image="/images/data-viz-maps/map-scatter.png"
          tags={['correlation']}
        />
      </div>

      <PaginationStyled
        previousLink="/data-visualization/bars"
        previous="Bars"
        nextLink="/data-visualization/tables"
        next="Tables"
        className="footer-pagination"
      />
    </div>
  </div>
);

const StyledMapsPage = styled(MapsPage)`
  > .sidebar {
    overflow-x: hidden;
    height: calc(100vh - 4rem);
  }

  > .content {
    overflow-x: hidden;
    margin: 0 auto;
    width: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;

    > .breadcrumbs {
      margin-bottom: 24px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        margin-bottom: 40px;
      }
    }

    > .cards {
      display: grid;
      grid-template-columns: repeat(1, 1fr);
      gap: 16px;

      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        grid-template-columns: repeat(2, 1fr);
        margin-bottom: 80px;
      }

      @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    > .footer-pagination {
      display: none;
      margin-top: auto;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        display: block;
      }
    }
  }
`;

export default StyledMapsPage;
